enum ValidationRule {
   NotEmpty,
   Length,
   Capacity,
   Custom,
   MinMax,
   IsEmail,
   StrongPassword,
   IsNumberString,
   Match,
}

export default ValidationRule